import { Component, Input } from '@angular/core';
import { SelectItem } from 'primeng/components/common/selectitem';
import { BaseStepComponent } from '../../base';

@Component({
  selector: 'base-homologacao',
  templateUrl: './base-homologacao.component.html'
})
export class BaseHomologacaoComponent extends BaseStepComponent {

  @Input() listaUsuario: SelectItem[];
  @Input() listaAtividade: SelectItem[];
  @Input() listaPontuacao: SelectItem[];
  @Input() listaUsuarioPedencia: SelectItem[];
  @Input() modal: number;
  @Input() deferido: string;
  @Input() idNorma: number;
  @Input() etapa: number;
  @Input() cargaHoraria: number;
  @Input() anos: number;
  @Input() listaPntCRC: any[];
  @Input() listaPntCFC: any[];
  @Input() gerenciamentoAtividade = `Docência`;
  pontuacaoApoio: any;


  replicarPontuacao(evento) {

    const replica = [];

    if (evento === true) {
      this.pontuacaoApoio = this.cadastro.controls.pontuacao_homologacao_atividade.value;

      this.listaPntCRC.forEach(element => {
        replica.push({
          id_pontuacao: this.pontuacaoApoio.filter(x => x.label === element.name)[0].id_pontuacao,
          label: element.name,
          valor: element.values,
          valor_pontuacao: null,
        })
      });

      this.cadastro.controls.pontuacao_homologacao_atividade.reset();
      this.cadastro.controls.pontuacao_homologacao_atividade.setValue(replica)

    } else {
      this.cadastro.controls.pontuacao_homologacao_atividade.setValue(this.pontuacaoApoio);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/Componentes/base-homologacao/base-homologacao.component.ts